import React from 'react';
import { DropDown } from './common';
import { DuLieuHeThong } from 'api';
import { validatable } from 'components/utils';

class DropDownChonHuongXuLyTheoDon extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      updated: false,
      data: [],
      allData: []
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  componentDidMount() {
    this.loadData(this.props.donId, this.props.loaiDon);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.loaiDon != nextProps.loaiDon) {
      this.loadData(nextProps.donId, nextProps.loaiDon);
    }
  }

  loadData(donId, loaiDon) {
    DuLieuHeThong.actions.getHuongXuLyTheoDon.request({donId: donId, loaiDon: loaiDon}).then(res => {

      if (typeof res.data != "undefined") {
        // TODO: Use Redux

        this.setState({
          data: res.data
        })
      } else {
        this.setState({
          data: []
        })
      }
    }).catch(err => {})
  }

  render() {
    return (
      <DropDown
        bindValidator={this}
        channel="formTaoDon"
        isValid={this.props.isValid}
        require={this.props.require}
        selectedValue={this.props.selectedValue}
        label="Hướng xử lý"
        options={this.state.data}
        keyName='giaTri'
        valueName='ten'
        onChange={this.onChange.bind(this)}
        placeholder={this.props.placeholder}
        className={this.props.className}
        name={this.props.name}/>
    )
  }
}

DropDownChonHuongXuLyTheoDon.defaultProps = {
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name:''
}

export default validatable(DropDownChonHuongXuLyTheoDon);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonhuongxulytheodon.jsx